import { FC, ReactNode } from "react";

type BannerProps = {
  readonly children: ReactNode;
  readonly id?: string;
};

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
export const Banner: FC<BannerProps> = (props) => {
  return (
    <div
      id={props.id}
      className="tw-bg-white tw-py-3 tw-px-6 tw-shadow-md tw-flex tw-justify-between tw-items-center tw-gap-4 tw-rounded-md tw-relative"
    >
      {props.children}
    </div>
  );
};
